import { Badge } from '@ovotech/nebula';
import React from 'react';

export const GenericPageError = () => (
  <Badge id="page-error" variant="error">
    There was a problem retrieving your data. Please refresh the page or try
    again later.
  </Badge>
);
